import ApisService from './index'
import { handleError } from '../utils/commonUtils'
import * as queryString from 'query-string'
import { IDuAn } from '../interfaces/duAnInterfaces'

export function createDuAn(data: IDuAn) {
  try {
    return ApisService.post('/duan/create-duan', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function updateDuAn(data: IDuAn) {
  try {
    return ApisService.put('/duan/' + data.id + '/update-duan', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function getDetailDuAn(id: string) {
  try {
    return ApisService.get('/duan/' + id + '/get-chitiet-duan')
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function getListDuAn(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/duan/filter-duan', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}
